<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Inhuur</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
@if (form) {
    <div class="row" mat-dialog-content>
        <form class="col-24" [formGroup]="form">
            <mat-form-field class="w-100" id="name">
                <input [formControl]="form.controls.name" matInput name="name" placeholder="Naam" type="text" />
            </mat-form-field>
            <mat-form-field class="w-100" id="phone">
                <input [formControl]="form.controls.phone" matInput name="phone" placeholder="Telefoon" type="text" />
            </mat-form-field>
            <mat-form-field class="w-100" id="email">
                <input
                    [formControl]="form.controls.email"
                    matInput
                    name="email"
                    placeholder="E-mailadres"
                    type="text" />
            </mat-form-field>
            <h3>Verhuur van materieel</h3>
            <mat-selection-list [formControl]="form.controls.entityTypes">
                @for (entityType of entityTypes; track entityType) {
                    <mat-list-option [value]="entityType.key" checkboxPosition="before">
                        {{ entityType.name }}
                    </mat-list-option>
                }
            </mat-selection-list>
        </form>
    </div>
}

<div class="col-24" mat-dialog-actions>
    <div class="d-flex justify-content-between mt-5">
        <button (click)="close()" mat-button>Annuleren</button>

        <button [disabled]="saving" (click)="save()" color="primary" mat-raised-button>
            Opslaan
            @if (saving) {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </button>
    </div>
</div>
